import React, { useState, useEffect } from 'react';
import { Modal, Checkbox, Input, Form } from 'antd';
import { apiHolder, apis, api, inWindow } from 'api';
import CloseIcon from '@/images/icons/modal-close-btn.svg';
import { getShowOld } from '@web-common/components/util/webmail-util';
import style from './OldVersionEntry.module.scss';
import { getIn18Text } from 'api';
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const systemApi = api.getSystemApi();
const webmailApi = apiHolder.api.requireLogicalApi(apis.webmailApiImpl);
const { TextArea } = Input;
const CloseLabel = {
    '0': getIn18Text('GUANBI'),
    '1': getIn18Text('HUIDAOJIUBAN'),
    '2': getIn18Text('JIXUSHIYONG'),
};
export const OldVersionModal = props => {
    const { defaultVisible, title, closeModal } = props;
    const [visible, setVisible] = useState(false);
    const [optionValue, setOptionValue] = useState([]);
    const [closeReason, setCloseReason] = useState('');
    const [content, setContent] = useState('');
    const options = [
        { label: getIn18Text('ZHAOBUDAOGONGNENG'), value: 'optionOne' },
        { label: getIn18Text('YEMIANKADUN'), value: 'optionTwo' },
        { label: getIn18Text('YEMIANBUJUSHI'), value: 'optionThree' },
    ];
    const handleClose = () => {
        var _a;
        let option;
        let reasonLabel = CloseLabel[closeReason];
        switch (closeReason) {
            case '0':
                option = {
                    buttonName: reasonLabel,
                };
                break;
            case '2':
                option = {
                    buttonName: reasonLabel,
                };
                break;
            case '1':
                if (content.length > 200) {
                    return;
                }
                option = {
                    buttonName: reasonLabel,
                    optionOne: optionValue.includes('optionOne'),
                    optionTwo: optionValue.includes('optionTwo'),
                    optionThree: optionValue.includes('optionThree'),
                    content,
                };
                break;
        }
        setOptionValue([]);
        setContent('');
        option.source = title;
        trackApi.track('click_button_backWebmailPage_lingx', option);
        if (closeReason === '1') {
            let sid = ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.sessionId) || '';
            const hl = inWindow() && window.systemLang === 'en' ? 'en_US' : 'zh_CN';
            const SHOW_OLD = getShowOld();
            location.assign('/js6/upgrade.jsp?style=13&sid=' + sid + '&show_old=' + SHOW_OLD + '&hl=' + hl);
        }
    };
    useEffect(() => {
        setVisible(defaultVisible);
    }, [defaultVisible]);
    return (React.createElement(Modal, { destroyOnClose: true, width: 480, visible: visible, title: React.createElement("div", { className: style.modalTitle }, getIn18Text('SHISHENMEYUANYIN')), closeIcon: React.createElement("img", { style: {
                width: '16px',
                height: '16px',
            }, src: CloseIcon }), className: `extheme ${style.oldEntryModal}`, okText: CloseLabel['1'], cancelText: CloseLabel['2'], onOk: () => {
            setCloseReason('1');
            if (content.length > 200) {
                return;
            }
            closeModal();
        }, onCancel: () => {
            setCloseReason('0');
            closeModal();
        }, maskClosable: false, afterClose: handleClose, cancelButtonProps: {
            onClick() {
                setCloseReason('2');
                closeModal();
            },
        } },
        React.createElement(Form, null,
            React.createElement(Checkbox.Group, { options: options, value: optionValue, onChange: value => {
                    setOptionValue(value);
                } }),
            React.createElement(Form.Item, { name: "input", rules: [
                    ({ getFieldValue }) => ({
                        validator(_, value) {
                            if (value && value.length > 200) {
                                return Promise.reject(new Error(getIn18Text('QINGSHURU20')));
                            }
                            return Promise.resolve();
                        },
                    }),
                ] },
                React.createElement(TextArea, { className: style.oldEntryFeedback, value: content, onChange: e => setContent(e.target.value), placeholder: getIn18Text('QINGSHURU20') })))));
};
